import { render, staticRenderFns } from "./SubjectBalance.vue?vue&type=template&id=32cc128f"
import script from "./SubjectBalance.vue?vue&type=script&lang=js"
export * from "./SubjectBalance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports